/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import * as React from "react";
import { useField } from "formik";

// Components
import Label from "../Label/Label";
import ErrorText from "../ErrorText/ErrorText";
import FeedbackText from "../FeedbackText/FeedbackText";
import RadioElement from "./RadioElement";

// Interfaces
import Answer from "../../types/Answer.interface";
import Feedback from "../../types/Feedback.interface";

// Misc.
import { useConditionDispatch } from "../../context/Condition.context";
import useFeedback from "../../lib/useFeedback.lib";
import "./InputRadio.scss";

interface InputRadio {
  id: string;
  label: string;
  answers: Answer[];
  feedback: Feedback[];
}

const InputRadio: React.FC<InputRadio> = (props: InputRadio) => {
  const { id, label, answers, feedback } = props;
  const [field, meta, helper] = useField(id);
  const [feedbackData] = useFeedback(feedback, field);
  const condDispatch = useConditionDispatch();

  const [inputValues, setInputValues] = React.useState<any>({});

  const setFieldValue = (value: any) => {
    helper.setValue(value);
    // helper.setTouched(true);
  };

  const checkMetaValueAndSetInput = (answer: Answer) => {
    if (
      meta.initialValue.id === answer._id &&
      inputValues[answer._id] === undefined
    ) {
      // Check if answer with textfield is initialValue. If true, set value of input field
      setInputValues({ ...inputValues, [answer._id]: meta.initialValue.value });
    }
  };

  const renderRadioAnswer = (answer: Answer): React.ReactNode => {
    if (answer.answer.includes("%text_field%")) {
      checkMetaValueAndSetInput(answer);

      const textFieldRegex = new RegExp(/(%text_field%)/, "g");
      const formattedAnswer = answer.answer.split(textFieldRegex);

      return (
        <span className="leading-tight">
          {formattedAnswer.map((part: string, index: number) => {
            return part.match(textFieldRegex) ? (
              <input
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                type="text"
                className="py-1 px-3 text-dw-grey-14 inline-block rounded-none"
                id={`${answer._id}-custom`}
                value={inputValues[answer._id] || ""}
                maxLength={150}
                onFocus={(e) => {
                  setInputValues({
                    ...inputValues,
                    [answer._id]: e.target.value,
                  });
                  setFieldValue({ id: answer._id, value: e.target.value });
                  condDispatch({
                    type: "add",
                    payload: {
                      [id]: { id: answer._id, value: e.target.value },
                    },
                  });
                }}
                onChange={(e) => {
                  setInputValues({
                    ...inputValues,
                    [answer._id]: e.target.value,
                  });
                  setFieldValue({ id: answer._id, value: e.target.value });
                }}
              />
            ) : (
              part
            );
          })}
        </span>
      );
    }

    return <span className="leading-tight">{answer.answer}</span>;
  };

  const renderRadioInput = (answer: Answer): React.ReactNode => {
    const includesTextField = answer.answer.includes("%text_field%");

    return (
      <RadioElement
        statementId={id}
        answer={answer}
        field={field}
        meta={meta}
        helper={helper}
        value={includesTextField ? inputValues[answer._id] : answer.answer}
      />
    );
  };

  return (
    <fieldset>
      <Label as="legend">{label}</Label>
      <div>
        {answers.map((answer: Answer) => (
          <div
            key={answer._id}
            className="input-radio my-4 last:mb-0 flex items-center"
          >
            {renderRadioInput(answer)}
            <label
              htmlFor={answer._id}
              className="cursor-pointer text-dw-grey-14"
            >
              {renderRadioAnswer(answer)}
            </label>
          </div>
        ))}
      </div>
      {meta.error && meta.touched && (
        <ErrorText text={(meta.error as any).value} />
      )}
      {feedbackData && field.value.value && (
        <FeedbackText text={feedbackData} />
      )}
    </fieldset>
  );
};

export default InputRadio;
